import { getSupabaseBrowserClient } from '../lib/supabase'

type RpcError = { message: string }
type RpcResponse = PromiseLike<{ data: unknown; error: RpcError | null }>
type RpcInvoker = (functionName: string, args?: Record<string, unknown>) => RpcResponse

export type AiUsePrivateProduct = {
  aiUseCaseId?: string
  privateProductId: string
  productName: string
  supplierName: string | null
  moderationStatus: string
}

function object(value: unknown): Record<string, unknown> { return value && typeof value === 'object' && !Array.isArray(value) ? value as Record<string, unknown> : {} }
function rows(value: unknown): Record<string, unknown>[] { return Array.isArray(value) ? value.map(object) : [] }
function text(value: unknown): string { return typeof value === 'string' ? value : '' }
function maybe(value: unknown): string | null { return typeof value === 'string' && value ? value : null }

async function invoke(functionName: string, args: Record<string, unknown>) {
  const client = getSupabaseBrowserClient() as unknown as { rpc: RpcInvoker }
  const { data, error } = await client.rpc(functionName, args)
  if (error) throw new Error(error.message)
  return data
}

function mapProduct(row: Record<string, unknown>): AiUsePrivateProduct {
  return {
    aiUseCaseId: maybe(row.aiUseCaseId) ?? undefined,
    privateProductId: text(row.privateProductId),
    productName: text(row.productName),
    supplierName: maybe(row.supplierName),
    moderationStatus: text(row.moderationStatus),
  }
}

export async function listAiUsePrivateProducts(organisationId: string): Promise<AiUsePrivateProduct[]> {
  return rows(await invoke('list_ai_use_case_private_products', { p_organisation_id: organisationId })).map(mapProduct)
}

export async function getAiUsePrivateProduct(aiUseCaseId: string): Promise<AiUsePrivateProduct | null> {
  const row = object(await invoke('get_ai_use_case_private_product', { p_ai_use_case_id: aiUseCaseId }))
  return Object.keys(row).length > 0 ? mapProduct(row) : null
}
